export default __webpack_public_path__ + "public/images/place_order.svg";